<svg-icon class="ui-dialog-close" src="/assets/icons/cross-thing.svg" uiDialogClose></svg-icon>

<form #form="ngForm" (ngSubmit)="onSubmit(form)" novalidate>

  <h3>
    {{sample.name}}
  </h3>

  <div class="preview">
    <img [src]="sample.previewUrl" />
    <div class="settings">
      <div class="item" *ngIf="sample.region">
        <label>Region of invoice</label>
        <span>{{regionName(sample.region)}}</span>
      </div>
      <div class="item">
        <label>Pages</label>
        <span>{{sample.pages}}</span>
      </div>
      <ui-selectbox name="export_format" class="format" [(ngModel)]="orderSettings.exportFormat"
        (ngModelChange)="onHideError()" placeholder="Output format" required>
        <ui-option value="Xml">.XML</ui-option>
        <ui-option value="Xls">.XLS</ui-option>
        <ui-option value="Csv">.CSV</ui-option>
        <ui-option value="Dbf">.DBF</ui-option>
        <ui-option value="Txt">.TXT</ui-option>
      </ui-selectbox>
      <div class="item">
        <label>Verify documents</label>
        <ui-radio-group name="verificationType" [(ngModel)]="orderSettings.verificationType"
          (ngModelChange)="onHideError()" placeholder="Verify documents">
          <ui-radio value="UserVerification">Yes</ui-radio>
          <ui-radio value="NoVerification">No</ui-radio>
        </ui-radio-group>
      </div>
    </div>
  </div>
  <p class="ui-input-error actions--text-error" [ngSwitch]="error" [class.visible]="error">
    <span *ngSwitchDefault><span *ngIf="error" [innerHTML]="errorDescription"></span></span>
  </p>
  <div class="actions">
    <button class="default start" type="submit" [disabled]="form.invalid">Start Processing</button>
  </div>

  <ui-loading *ngIf="processing"></ui-loading>

</form>
